// Placeholder screens for sidebar destinations not yet ported. Each
// non-dashboard surface in the trader-workstation reference (Briefing,
// Watchlist, Day trades, Positions, Investments, Research, Journal,
// Config, System) lands in subsequent Phase 4 commits.

import type { ReactNode } from "react";

type Props = { title: string; note: string; cta?: ReactNode };

export const StubScreen = ({ title, note, cta }: Props) => (
  <div data-screen-label={title}>
    <div className="tp-page-head">
      <h1>{title}</h1>
      <div className="meta">scaffold</div>
    </div>
    <div className="tp-tile">
      <div className="tp-tile-body" style={{ color: "var(--tp-fg-3)" }}>
        {note}
        {cta && <div style={{ marginTop: 14 }}>{cta}</div>}
      </div>
    </div>
  </div>
);
